<template>
    <!-- Breadcrumb -->
    <div class="breadcrumb mb-0">
        <span class="primary-right-round"></span>
        <div class="container">
            <h1 class="text-white">{{title}}</h1>
            <ul class="list-unstyled">
                <li><router-link to="/index">{{text}}</router-link></li>
                <li>{{text1}}</li>
            </ul>
        </div>
    </div>
    <!-- /Breadcrumb -->
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    text1: {
      type: String,
      default: "",
    },
  },
};
</script>